<template>
  <div>
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import lodash from "lodash";

export default {
  name: "BarGraph",
  props: {
    data: {
      type: Array,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
      labels: [],
      dataSet: [],
      borders: [],
      palette: [],
      // colors: [
      //   "#B2FF59",
      //   "#FF5722",
      //   "#FFFF00",
      //   "#00E5FF",
      //   "#006064",
      //   "#69F0AE",
      //   "#00B0FF",
      //   "#26A69A",
      //   "#9575CD",
      //   "#EF5350",
      //   "#18FFFF",
      //   "#039BE5",
      //   "#B2FF59",
      //   "#FFCA28",
      // ],
      colors: [
        "#2196F3",
        "#18FFFF",
        "#84FFFF",
        "#006064",
        "#29B6F6",
        "#00ACC1",
        "#536DFE",
        "#26C6DA",
        "#82B1FF",
        "#80DEEA",
        "#18FFFF",
        "#039BE5",
        "#CFD8DC",
        "#00B8D4",
      ],
      // colors: [
      //   "#463240","#4E4051","#534E62","#555D72","#556E81","#547E8E","#538F98","#54A09F",'#59B0A3','#64C1A4',"#76D1A3",'#8DE0A0',"#A9EE9B"
      // ]
      // colors: ['#64DD17', '#76FF03', '#B2FF59', '#CCFF90', '#AEEA00', '#C6FF00', '#EEFF41', '#F4FF81', '#FFFF00', '#FFC400', '#18FFFF', '#039BE5', '#B2FF59', '#FFCA28'],

      // colors: ['#FF5722', '#A1887F', '#FFC400', '#00796B', '#84FFFF', '#2979FF', '#FF80AB', '#E53935', '#4DD0E1', '#80DEEA', '#18FFFF', '#039BE5', '#B2FF59', '#FFCA28'],
    };
  },
  mounted() {
    let sortedArray = lodash.orderBy(this.data, "count", "desc");
    this.labels = sortedArray.map((item) => item.title);
    this.dataSet = sortedArray.map((item) => item.count);
    this.createChart(this.id);
  },
  computed: {
    options() {
      return {
        aspectRatio: 1,
        responsive: true,
        legend: {
          position: "left",
          align: "start",
          fontColor: "white",
          fontSize: 18,
          labels: {
            fontColor: "white",
            padding: 9,
          },
        },
        title: {
          display: false,
          text: "Chart.js Doughnut Chart",
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
        tooltips: {
          enabled: true,
        },
        borderColor: "#FFFFFF",
        scale: {
          ticks: {
            display: false,
          },
          pointLabels: {
            fontSize: 20,
          },
        },
      };
    },
  },
  methods: {
    createChart(chartId) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: "polarArea",
        data: {
          labels: this.labels,
          datasets: [
            {
              label: "Test",
              data: this.dataSet,
              backgroundColor: this.colors,
              borderColor: "black",
              borderWidth: 0,
            },
          ],
        },
        options: this.options,
      });
    },
  },
};
</script>
